'use client'

import { createContext, ReactNode, useContext, useEffect, useRef, useState } from "react";
import LeftSide from "../aside/left_side";
import { DeviceContext } from "@/context/deviceContext";
import RightSide from "../aside/right_side";
import NavHeader from "../header/nav_header";
import OneLineNotice from "../oneLine";
import MainTopBanners from "./MainTopBanners";

const MainScrollContext = createContext<{
    setScrollTop: ()=> void
}>({
    setScrollTop: ()=> {}
})
export default function MainContainer({ children }: { children: ReactNode }) {
    const scrollRef = useRef<HTMLDivElement>(null)


    function setScrollTop(){
        scrollRef.current?.scrollTo({top: 0, behavior: "smooth"})
    }

    return (
        <MainScrollContext.Provider value={{setScrollTop}}>
            <main id="main-container" className="abside-layout"
            // style={{ height: `${mainH}px` }}
            >
                <LeftSide />
                <div id="center-side">
                    <NavHeader />
                    <OneLineNotice />
                    <MainTopBanners />
                    <div className="scroll-layout" ref={scrollRef}>
                        {children}
                    </div>
                </div>
                <RightSide />
            </main>
        </MainScrollContext.Provider>
    )
}

export const useMainScroll = ()=> useContext(MainScrollContext)